import { render, staticRenderFns } from "./SummaryCargoStolen.vue?vue&type=template&id=050e11f2&scoped=true&"
import script from "./SummaryCargoStolen.vue?vue&type=script&lang=js&"
export * from "./SummaryCargoStolen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050e11f2",
  null
  
)

export default component.exports